exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fieldSettingsItem{\r\n    transition: border-color 200ms ease-in-out;\r\n    border:1px solid;\r\n    border-color: transparent;\r\n}\r\n\r\n.fieldSettingsItem.IsOpen{\r\n    border-color: #dfdfdf;\r\n}", ""]);

// exports
